import { useAuth } from "@/context/AuthContext";
import { ShieldOff } from "lucide-react";

export const PERMS = [
  ["vouchers", "Create / Edit", "Invoices, receipts, journal vouchers, customers, products & prices"],
  ["download", "Download PDF", "Download any document or report as PDF"],
  ["share", "Share WhatsApp", "Share documents via WhatsApp"],
  ["reports", "Reports", "Day Book, product sales, registers"],
  ["import_export", "Import / Export", "CSV import, mass export, backup & restore"],
  ["settings", "Settings", "Edit company details"],
];

export default function Can({ perm, children, fallback = null }) {
  const { can } = useAuth();
  return can(perm) ? children : fallback;
}

export function NoAccess({ what = "this page" }) {
  return (
    <div className="bg-white border border-slate-200 rounded-md p-10 text-center text-slate-500" data-testid="no-access">
      <ShieldOff size={28} className="mx-auto mb-3 text-slate-300" />
      <div className="text-sm font-semibold text-slate-700">You don't have access to {what}</div>
      <div className="text-xs mt-1">Ask your administrator to grant the permission in Settings → Team.</div>
    </div>
  );
}
